// FYI: This is a temporary object for demo purposes to show how virtual dropdown is rendered.
// TODO: Remove when we have dropdown css variables on the root menu level
export const virtualMenuDropdownMenuCssVariables = {
  '--item-background': '255,255,255',
  '--item-font':
    'normal normal normal 16px/1.6em madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif',
  '--item-color': 'rgba(var(--color_15),1)',
  '--item-text-transform': 'revert',
  '--item-text-outline':
    '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
  '--item-text-highlight': 'none',
  '--item-letter-spacing': 'revert',
  '--item-line-height': 'revert',
  '--item-text-shadow': '0px 0px 0px transparent',
  '--item-border-left': '0px none rgba(var(--color_15),1)',
  '--item-border-right': '0px none rgba(var(--color_15),1)',
  '--item-border-top': '0px none rgba(var(--color_15),1)',
  '--item-border-bottom': '1px solid rgba(var(--color_15),1)',
  '--item-border-radius': '0 0 0 0',
  '--item-box-shadow': 'none',
  '--sub-item-background': '255,255,255',
  '--sub-item-font':
    'normal normal normal 16px/1.6em madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif',
  '--sub-item-color': 'rgba(var(--color_15),1)',
  '--sub-item-text-transform': 'revert',
  '--sub-item-text-outline':
    '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
  '--sub-item-text-highlight': 'none',
  '--sub-item-letter-spacing': 'revert',
  '--sub-item-line-height': 'revert',
  '--sub-item-text-shadow': '0px 0px 0px transparent',
  '--sub-item-border-left': 'medium none currentcolor',
  '--sub-item-border-right': 'medium none currentcolor',
  '--sub-item-border-top': 'medium none currentcolor',
  '--sub-item-border-bottom': 'medium none currentcolor',
  '--sub-item-border-radius': '0 0 0 0',
  '--sub-item-box-shadow': 'none',
  '--container-background': '255,255,255',
  '--container-box-shadow': 'none',
  '--container-border-left': 'medium none currentcolor',
  '--container-border-right': 'medium none currentcolor',
  '--container-border-top': 'medium none currentcolor',
  '--container-border-bottom': 'medium none currentcolor',
  '--container-border-radius': '0 0 0 0',
  '--container-vertical-padding': '10px',
  '--container-horizontal-padding': '10px',
  '--item-hover-color': 'rgba(var(--color_18),1)',
  '--sub-item-vertical-padding': '4px',
  '--sub-item-hover-color': 'rgba(var(--color_18),1)',
  '--item-align': 'inherit',
  '--item-vertical-spacing': '0px',
  '--align': 'start',
  '--sub-items-vertical-spacing-before': '0',
  '--sub-items-vertical-spacing-between': '0',
  '--columns-number': '2',
  '--sub-item-align': 'inherit',
  '--sub-item-horizontal-padding': '0',
  '--item-vertical-padding': '4px',
  '--item-horizontal-padding': '0',
  '--item-horizontal-spacing': '10px',
} as React.CSSProperties;
